import { BlockProps, LinkProps, SvgSelectorProps } from "@/utils/types";
import { BlockWrapper } from "./BlockWrapper";
import { SvgSelector } from "../SvgSelector";
import Link from "next/link";
import { Portable } from "../utility/Portable";
import { sanitize } from "@/utils/sanitize";
import WavePattern from "../modules/WavePattern";
import { addBreak } from "@/utils/addBreak";

interface BigBannerProps extends BlockProps {
  svg: SvgSelectorProps["name"];
  message?: any[];
  link?: LinkProps;
}

export const BigBanner = ({
  backgroundColor = "bg-white",
  bottom,
  className,
  colorStarter,
  componentId,
  heading,
  primaryEnder,
  ...props
}: BigBannerProps) => {
  const lightMode =
    sanitize(backgroundColor) === "bg-white" ||
    sanitize(backgroundColor) === "pattern" ||
    sanitize(backgroundColor) === "bg-secondary" ||
    sanitize(backgroundColor) === "bg-tertiary";

  const blockProps = {
    backgroundColor,
    bottom,
    colorStarter,
    componentId,
    lightMode,
    primaryEnder,
  };
  const HeadingTag = (
    heading?.headlingLevel === 0 ? "p" : `h${heading?.headlingLevel}`
  ) as keyof React.JSX.IntrinsicElements;

  const textColor = lightMode ? "text-primaryShade" : "text-white";

  return (
    <BlockWrapper
      {...blockProps}
      className={`bigBanner${className ? ` ${className}` : ""}`}
    >
      <div className="contained flex items-center justify-between flex-col md:flex-row gap-8 md:gap-0 text-center md:text-start">
        <SvgSelector
          name={props.svg}
          className="md:w-[295px] w-[200px] h-auto"
        />

        <div className="copy flex flex-col gap-4 justify-start items-start">
          {heading && (
            <HeadingTag
              className={`font-display w-full  text-3xl xs:text-[10svw] mdxl:text-[100px] ${textColor} text-pretty leading-[1]`}
            >
              {addBreak(heading.copy || "", 2)}
            </HeadingTag>
          )}

          <WavePattern waves={5} thickness={3} className="hidden md:block" />
          {props.message && (
            <Portable
              className={`${textColor} md:max-w-[400px]`}
              gap="gap-2"
              content={props.message}
            />
          )}
          {props.link && props.link.href && (
            <Link
              className={`button ${lightMode ? (backgroundColor === "bg-tertiary" ? "secondary" : "tertiary") : "primary"} mx-auto md:mx-0 ${
                props.link.className ? ` ${sanitize(props.link.className)}` : ""
              }`}
              href={props.link.href}
            >
              {props.link.copy}
            </Link>
          )}
        </div>
      </div>
    </BlockWrapper>
  );
};
